<div class="topo-bg">
<div class="d-lg-flex position-relative">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css">
  <div class="container d-lg-flex min-height-lg-100vh padding-top-custom">
    <div class="row">
      <div class="col-sm-12 col-lg-8 mb-lg-0 desktop-marg">
        <!-- Info -->
        <div class="mb-5">
          <h1 class="display-1 font-size-md-down-5 font-weight-bold mb-5" style="font-size: 45px">
            <span class="text-fg">
              <ngx-typed-js class="disp"
                            [strings]="['Certified.', 'Professional.', 'Dedicated.']"
                            [showCursor]='true'
                            [loop]='true'
                            [typeSpeed]=100
                            [backSpeed]=50>
                <span class="text-fg-alt font-weight-normal">Who Are We?</span>
                <br>
                <span>We are<br></span>
                   <strong class="typing"></strong>
                </ngx-typed-js>
            </span>
          </h1>
          <p class="text-fg-alt">Our Kilimanjaro staff provide the pinnacle of service. Kopa Tours' staff care about
            <b><i>your</i></b> climb.</p>
        </div>

        <div class="mobile-margin d-block mb-1">
          <app-kopa-button link="../../helpful-information/our-guides" color="secondary" fragment="qualifications" text="Guide Qualifications" classes="mb-2 mb-sm-0 mr-3" chevronDir="down"></app-kopa-button>
          <app-kopa-button link="../../helpful-information/our-guides" color="secondary" fragment="jambo" text="Our Staff in Action" classes="mb-2 mb-sm-0 mr-3" chevronDir="down"></app-kopa-button>
        </div>
      </div>
      <!-- SVG Illustration -->
      <div id="SVGMainHero" class="col-lg-8 col-xl-7 d-none d-lg-block position-absolute z-index-n1 top-0 right-0 pr-0 overflow-hidden">
        <img style="max-height:700px;" appWidth=1244 appHeight=700 appLazyload="1244x700/snow-hike.png">
      </div>
      <!-- End SVG Illustration -->
    </div>
  </div>
</div>

<div class="container d-xs-flex align-items-xs-center min-height-xs-100vh negativeDeskMargin">
  <div class="text-center mb-2 mt-5 display-3 text-mobile-left"><strong>Who Makes Up Our Staff?</strong></div>
  <div class="row">
    <div *ngIf="!isMobile()" class="col-sm-12 col-lg-6 offset-lg-6  text-center mt-3">
      <h3 class="text-fg-alt font-weight-bold">Guides<app-fa-icon iconName="male" color="fg-alt-color" classes="ml-2"></app-fa-icon></h3>
    </div>
  </div>
  <div class="row">
    <div class=" col-sm-12 col-lg-6 my-auto">
      <div class="text-center my-auto mx-auto">
        <img class="mx-auto w-100 my-auto" appWidth=600 appHeight=350 appLazyload="600x350/guide-uhuru.jpg">
      </div>
    </div>
    <div class="col-sm-12 col-lg-6 ">
      <h3 *ngIf="isMobile()" class="text-fg-alt text-center font-weight-bold mt-3 col-12">Guides<app-fa-icon iconName="male" color="fg-alt-color" classes="ml-2"></app-fa-icon></h3>
      <h3 class="text-white text-center text-mobile-left">
        Highly Qualified, Certified, and Friendly <strong>Guides</strong> that are Committed to Your Success.
      </h3>
      <p class="text-white font-weight-normal">The coveted title of ‘mountain guide’ is not earned easily at Kopa Tours.
        Each of our guides began their journey as a porter - carrying necessary supplies up the mountain to ensure the success of climbers.
        On each trip, porters become more knowledgeable (and strong!) as they learn from the seasoned guides they travel with.
      </p>
      <p class="text-white font-weight-normal">
        Every guide at Kopa Tours has undergone schooling which is offered through the Mount Kilimanjaro Porters Society.
        The guides of Kopa Tours are fluent in English and many other languages as well.
        Our guides support our community - they lead our climbers safely, teach the other staff members about the mountain,
        and ensure the safety of all involved on the climb.
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12 col-lg-6  text-center mt-3">
      <h3 class="text-fg-alt font-weight-bold">Assistant Guides<app-fa-icon iconName="user" color="fg-alt-color" classes="ml-2"></app-fa-icon></h3>
    </div>
  </div>
  <div class="row mb-5">
    <div class="col-sm-12 col-lg-6">
      <h3 class="text-white text-center text-mobile-left">
        Intelligent and Professional <strong>Assistant Guides</strong> that diligently look after you along your way.
      </h3>
      <p class="text-white font-weight-normal">
        Before they become head guides, all of our guides take the role of assistant guide on treks up the mountain.
        Our head guides are in charge of the safety of all Kopa climbers and Kopa Tours team members while also mentoring assistant guides.
      </p>
      <p class="text-white font-weight-normal">
        When head guides are busy taking care of the team, assistant guides will take the lead on the trail.
        Assistant guides will also perform daily health checks and respond in the case of an emergency.
      </p>
    </div>
    <div class="col-sm-12 col-lg-6 my-auto">
      <div class="text-center my-auto h-50">
        <img class="mx-auto my-auto w-100" appWidth=600 appHeight=400 appLazyload="600x400/kili-summit-certificate-philip.jpg" alt="Kopa Tours Hiker receives their Kilimanjaro Summit Certificate">
      </div>
    </div>
  </div>
  <!-- Safety Card -->
  <div class="container lnt card mt-5" id="qualifications">
    <div class="row mx-auto">
      <div class="safetyHeader card-header w-100 container">
        <div class="row">
          <div class="col-12 col-md-3 col-lg-4 pb-2 text-center text-lg-left">
            <span appCuteIcon class="float-none float-lg-right" folder="components" type="safety-shield" sizeInPixels="128"></span>
          </div>
          <div class="col-12 col-md-9 col-lg-8 float-none float-lg-left mt-2 pb-2 text-center text-md-left">
            <h3 class="d-inline">
              <strong class="safetyheadertext mb-n2" style="font-size: 48px;">SAFETY COMES FIRST</strong>
              <br>
              <strong class="safetyheadertext mt-n2 align-text-top" style="font-size: 24px;">WHEN YOU CLIMB WITH KOPA TOURS</strong>
            </h3>
            <br class="clearfix d-block d-sm-none">
            <span appCuteIcon class="ml-1 ml-lg-2 mt-n2" folder="kopa-branding" type="full-logo-no-words" sizeInPixels="48"></span>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-sm-12">
        <div class="mx-auto mt-1 mt-md-3 mb-3 mb-lg-5 card-border">
          <div class="card-body">
            <p class="card-text font-weight-normal">Safety is our <b>number one</b> priority.
              Our Guides are the best on the mountain. Each Guide is certified and has 100+ Kilimanjaro climbs. Our crew is prepared in every way, and are here to ensure that your climb is safe on Kilimanjaro.
            </p>
            <p class="card-text font-weight-normal">Our guides are trained in how to detect, monitor and
              handle acute mountain sickness (AMS). Guides are formally trained in first aid, and carry all necessary medical
              equipment such as:</p>
              <div class="list ml-5 mb-3 font-weight-bold">
                <app-fa-icon iconName="heartbeat" color="fg-alt-color" classes="mr-1" width="2" height="2"></app-fa-icon> Oxygen level monitors<br><br>
                <app-fa-icon iconName="medkit" color="fg-alt-color" classes="mr-2" width="2" height="2"></app-fa-icon> Extra oxygen tanks<br><br>
                <app-fa-icon iconName="book-medical" color="fg-alt-color" classes="mr-2" width="2" height="2"></app-fa-icon><span class="medCharts"> Medical charts</span></div>
            <p class="card-text font-weight-normal">We react promptly and safely on any sign that you've become afflicted with acute mountain sickness.</p>
            <p class="card-text font-weight-normal">It takes a lot of effort to climb to the Roof of Africa.
              To do so safely and successfully, we provide you a crew of 7 on the mountain (Lead Mountain Guide, Assistant Mountain Guide, Waiter, Cook, and Porters).
              Having a large and supportive staff helps ensure your safety on the mountain.
              <br><br>
              From meal prep, to medical safety, to carrying your bag, all the way to clearing the path ahead of you and
              assisting on any steeper portion of the hike - we are here to make sure that each step you take is pleasant and safe. <b><i>Asante Sana!</i></b>
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="row h-100">
          <div class="col-12 border-qual">
            <h3 class="text-white mx-auto text-center mt-1 mt-md-3"><strong>Our Guide Qualifications</strong></h3>
              <ul class="text-left text-white lnt font-weight-normal list-group-borderless ml-2 ml-md-0">
                <li class="list-group-item lnt">Fully Licensed by Kilimanjaro National Park Service</li>
                <li class="list-group-item lnt">Each Guide and Assistant Guide have 100+ climbs under their belt, and multiple years of experience.</li>
                <li class="list-group-item lnt">Professionally trained to execute emergency rescue at any time and any location on the mountain.</li>
                <li class="list-group-item lnt">Able to lead and instruct Kilimanjaro Search & Rescue via helicopter.</li>
                <li class="list-group-item lnt">Promptly handle all emergencies using first aid protocol.</li>
                <li class="list-group-item lnt">Full fluency in English, Spanish, French, German, Russian, and many other languages.</li>
              </ul>
          </div>
          <div class="col-12 text-center my-4 my-lg-auto">
            <img class="w-80" appWidth=600 appHeight=450 appLazyload="600x450/staff-end-trek.jpg">
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End safety card -->
</div>
<div class="container">
  <div class="row mt-6">
    <div *ngIf="!isMobile()" class="col-sm-12 col-lg-6 offset-lg-6 text-center mt-1">
      <h3 class="text-fg-alt font-weight-bold">Porters<app-fa-icon iconName="people-carry" color="fg-alt-color" classes="ml-2"></app-fa-icon></h3>
    </div>
    <div class="col-sm-12 col-lg-6">
      <img class="mx-auto w-100 mb-2" appWidth=600 appHeight=350 appLazyload="600x350/guide-hiking.jpg">
      <img class="mx-auto w-100" appWidth=600 appHeight=350 appLazyload="600x350/porter-celebrating.jpg">
    </div>
    <div class="col-lg-6 col-sm-12">
      <h3 *ngIf="isMobile()" class="text-fg-alt mt-4 font-weight-bold text-center">Porters<app-fa-icon iconName="people-carry" color="fg-alt-color" classes="ml-2"></app-fa-icon></h3>
      <h3 class="text-white text-center text-mobile-left">
        Dedicated and Ambitious - Our <strong>Porters</strong> Work Humbly and Tirelessly to Fulfill Your Needs.
      </h3>
      <p class="text-left text-white font-weight-normal">
        Without porters, Kilimanjaro treks would not be successful.
        These diligent hard workers carry the majority of supplies up the mountain,
        collect and boil water along the route, and cheer for you all along the way.
        Porters rise early to break down camp, hike at a swift pace, and set up at the next camp
         - all while you & other trekkers are slowly making your way up the mountain.
        These men and women ensure the comfort and ease of a Kilimanjaro trek for our hikers.
      </p>
      <p class="text-left text-white font-weight-normal">
        Your porters live for the climb - the most high-spirited of the crew, they are a steady source of joy on the mountain.
        You will be impressed by their strength and agile ability to climb up the mountain. Further by their capability to carry pack loads on their heads!
        On your last day on the mountain, your porters celebrate your journey with a rendition of ‘Jambo Bwana’.
        This catchy tune will have you singing it your whole flight home.
        Your journey to the summit of Uhuru Peak may be over (thanks to your supportive team), but you will remember the good times and new founded friendships forever.
      </p>
    </div>
  </div>
<div class="row">
  <div id="jambo" class="mb-2 mt-2"></div>
    <div class="col-12 mb-3 mt-3 height-vid" >
      <iframe src="https://www.youtube.com/embed/pnXzXKPTIXw"
              style="border: 0px; text-align: center; width: inherit; height: inherit;"></iframe>
    </div>

    <div class="col-12">
      <p class=" text-white font-weight-normal mt-3">
        Our porters make treks to the summit possible, without them - hardly anyone would make it to the Roof of Africa.
        Kopa Tours encourages you to tip these amazing people - you can find our guideline for tipping on this page.
        Curious for more info? Read about how we <a routerLink="../../helpful-information/porters-society"><u>support our porters</u></a>.
        Lastly, you can read about how the <a href="http://www.kilimanjaro-porters.org/" target="_blank"><u>Mount Kilimanjaro Porters Society</u></a>
        (MKPS) organization aims to improve porters’ lives both on and off the mountain.
      </p>
    </div>
</div>
  <div class="row">
    <div class="col-lg-8 col-sm-12 mb-3">
      <h3 class="text-white text-center"><strong>Why You Need to Go Guided</strong></h3>
      <p class="text-left text-white font-weight-normal">
        Tanzanian Law requires everyone to climb Kilimanjaro with a guide.
        There are a lot of reasons why you need a guide on the mountain -
        they ensure your safety and set an appropriate pace while hiking the mountain.
        They carry safety equipment to check your oxygen level daily and monitor your emotional and
        physical well being while on the mountain. Guides carry emergency tanks of oxygen and other
        emergency equipment to be used as necessary along the trail.
      </p>
      <blockquote class="pl-3 text-fg">Your mountain staff carry all necessary equipment - devices to check your daily oxygen level, emergency tanks of oxygen, your daily meals, extra needed snacks, as well as
        emergency equipment if needed along the trail.</blockquote>
      <p class="text-left text-white font-weight-normal">
        Your team sets you up for success on the mountain - they know how difficult it is
        to reach the summit and support your comfort along the way. Each day,
        your team sets up and tears down your camp area and they also provide all water and food for your trip.
        They monitor your health to ensure that you are safe on the mountain.
      </p>
      <blockquote class="pl-3 text-fg">Hot breakfast, lunch, afternoon snacks and dinners are prepared and served for you each
        day on the mountain.</blockquote>
      <p>
        Leave the logistics of the mountain to us, Kopa Tours team will take care of all your needs for your climb.
        Focus for you is on maintaining a positive mindset and enjoying the beauty of Tanzania & Mount Kilimanjaro.
      </p>
    </div>
    <div class="col-12 col-sm-8 col-md-8 col-lg-5 col-xl-4 col-xl-4">
      <div class="position-sticky mt-5 mb-5" style="top:80px; position: -webkit-sticky">
        <app-trip-list
          [titleString]=tripListTitle
          [subtitleString]=tripListSubtitle
          headerColor="secondary"
          [hasTextShadow]="false"
          [entries]=tripEntries>
        </app-trip-list>
      </div>
    </div>

  </div>
</div>
</div>
